export default "__VITE_ASSET__5xb$cekB__"